import { useDispatch, useSelector } from 'react-redux';
import { useTranslation } from 'react-i18next';
import { makeStyles } from '@material-ui/core/styles';
import {
  addGAConditionsNode,
  addGAViewConditionsNode,
} from '../../../features/mainSlice';
import { color } from '../../../app/theme';
import Dropdown from '../../shared/Dropdown';
import { GATriggerType } from '../../../app/types';

const useStyles = makeStyles(
  {
    root: {
      marginBottom: 36,
    },
    title: {
      fontStyle: 'normal',
      fontWeight: 500,
      fontSize: 15,
      lineHeight: '15px',
      color: color.$3,
      marginBottom: 12,
    },
    dropdown: {
      width: 328,
    },
  },
  {
    name: 'TriggerType',
  },
);

const Type = () => {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const { selectedNode } = useSelector(state => state.ma);
  const { triggerType, source } = selectedNode?.data;

  const typeItem = [
    { text: t(`trigger.${GATriggerType.GAVIEW}`), value: GATriggerType.GAVIEW },
    {
      text: t(`trigger.${GATriggerType.GAREMOVEFROMCART}`),
      value: GATriggerType.GAREMOVEFROMCART,
    },
    {
      text: t(`trigger.${GATriggerType.GAADDTOCART}`),
      value: GATriggerType.GAADDTOCART,
    },
    {
      text: t(`trigger.${GATriggerType.GAPURCHASE}`),
      value: GATriggerType.GAPURCHASE,
    },
  ];

  const onChange = value => {
    switch (value) {
      case GATriggerType.GAVIEW:
        dispatch(addGAViewConditionsNode(source));
        break;
      case GATriggerType.GAREMOVEFROMCART:
      case GATriggerType.GAADDTOCART:
      case GATriggerType.GAPURCHASE:
        dispatch(addGAConditionsNode(source, value));
        break;
      default:
        break;
    }
  };

  return (
    <div className={classes.root}>
      <div className={classes.title}>{t('condition-setting.type')}</div>
      <Dropdown
        className={classes.dropdown}
        menuItems={typeItem}
        value={triggerType}
        onChange={onChange}
      />
    </div>
  );
};

export default Type;
